// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2463":"97612c9c532ffed8","4277":"ba28d88e768dc99f","6241":"39e6734619dc991d","6837":"af872482462d3f28"}[chunkId] + ".js";
};